
import { FILE_CONFIGS } from '@/config/file';
import { FileIcon } from 'lucide-react';

type FileIconInfo = {
  icon: typeof FileIcon;
  color: string;
}

export const getFileIconInfo = (fileName: string): FileIconInfo => {
  const extension = fileName.toLowerCase().slice(fileName.lastIndexOf('.'));
  
  const config = FILE_CONFIGS.find(config => 
    config.extensions.includes(extension)
  );

  return config || {
    icon: FileIcon,
    color: 'text-gray-400'
  };
};